import React from "react";
import PropTypes from "prop-types";
import { Button } from "../../stories/Buttons/Button";
import StepCard from "../../stories/Cards/StepCard";
import PageLayout from "../../components/Layout/PageLayout";
import { useAuth } from "../../components/AuthContext/AuthContext";
import LoggedInLayout from "../../stories/LoggedInScreens/LoggedInLayout";
import arrowRight from "../../assets/icons/Arrow-right.svg";

const CheckList = ({
  steps,
  icons,
  bodies,                 
  className = "",         
  selectedSteps,
  onToggle,
  onContinue,
  heading = "Prepare the sample for storage and collection",
  subHeading = (
    <>
      Complete and acknowledge all checklist items.
      <br />
      Once all items have been checked and acknowledged, click ‘<strong>Continue</strong>’.
    </>
  ),
  cardTitle,
  cardSubtitle = "Before returning the sample, please click to confirm all the below steps have been followed:",
  children,
}) => {
  const auth = useAuth();
  const isVhlogin = auth?.featureFlag;

  return (
    <LoggedInLayout isVhlogin={isVhlogin} vitalityLayout={isVhlogin}>
      <PageLayout heading={heading} subHeading={subHeading}>
        <div className={`confirm-card card vh-confirm-card ${className}`}>
          {cardTitle && <h2 className="vh-confirm-card__title">{cardTitle}</h2>}
          <p className="vh-confirm-card__subtitle pb-3 mb-3 border-bottom">
            {cardSubtitle}
          </p>
          <div className="container p-0">
            <div className="row">
              {steps.map((step) => (
                <StepCard
                    key={step.number}
                    {...step}
                    body={bodies?.[step.number] || step.body}    
                    image={icons?.[step.number] || step.image}
                    isSelected={selectedSteps.includes(step.number)}
                    isVh
                    onClick={() => onToggle(step.number)}
                />
              ))}
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-end mt-4">
        <Button
            className="vh-continue-btn"
            isDisabled={selectedSteps.length !== steps.length}
            label="Continue"
            onClick={onContinue}
            size="small"
            svg={arrowRight}
        />
        </div>
      </PageLayout>
      {children}
    </LoggedInLayout>
  );
};

CheckList.propTypes = {
  steps: PropTypes.array.isRequired,
  icons: PropTypes.object, 
  selectedSteps: PropTypes.array.isRequired,
  onToggle: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  heading: PropTypes.string,
  subHeading: PropTypes.node,
  cardTitle: PropTypes.string,
  cardSubtitle: PropTypes.string,
  children: PropTypes.node,
  bodies: PropTypes.object,
  className: PropTypes.string,
};

export default CheckList;